import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/fipe-next-ui-prd/src/app/error.tsx");
